const TABS = [
  { dow: "all", label: "XSMB", title: "XSMB" },
  { dow: 1, label: "Thứ 2", title: "XSMB Thứ 2" },
  { dow: 2, label: "Thứ 3", title: "XSMB Thứ 3" },
  { dow: 3, label: "Thứ 4", title: "XSMB Thứ 4" },
  { dow: 4, label: "Thứ 5", title: "XSMB Thứ 5" },
  { dow: 5, label: "Thứ 6", title: "XSMB Thứ 6" },
  { dow: 6, label: "Thứ 7", title: "XSMB Thứ 7" },
  { dow: 0, label: "CN", title: "XSMB Chủ nhật" },
];

const PRIZE_ROWS = [
  { label: "ĐB", key: "specialPrize", tr: "db", cls: "v-gdb", nc: 5, slots: 1, single: true },
  { label: "Giải 1", key: "prize1", tr: "", cls: "v-g1", nc: 5, slots: 1, single: true },
  { label: "Giải 2", key: "prize2", tr: "bg_ef", prefix: "v-g2", nc: 5, slots: 2 },
  { label: "Giải 3", key: "prize3", tr: "", prefix: "v-g3", nc: 5, slots: 6 },
  { label: "Giải 4", key: "prize4", tr: "bg_ef", prefix: "v-g4", nc: 4, slots: 4 },
  { label: "Giải 5", key: "prize5", tr: "", prefix: "v-g5", nc: 4, slots: 6 },
  { label: "Giải 6", key: "prize6", tr: "bg_ef", prefix: "v-g6", nc: 3, slots: 3 },
  { label: "Giải 7", key: "prize7", tr: "g7", prefix: "v-g7", nc: 2, slots: 4 },
];

const WEEK_COLS = [1, 2, 3, 4, 5, 6, 0];

const TITLES = [
  (date, rel) => `XSMB - Xổ số miền Bắc ${rel === "today" ? "hôm nay " : rel === "yesterday" ? "hôm qua " : ""}${date}`,
  (date, rel) => `KQXSMB - So xo mien Bac ${rel === "ereyesterday" ? "hôm kia " : ""}${date}`,
  (date) => `SXMB - XS miền Bắc ${date}`,
  (date) => `SSMB - Xổ số đài miền Bắc ${date}`,
  (date) => `XSKTMB - Xổ số kiến thiết miền Bắc ${date}`,
  (date) => `XSHN - Xổ số miền Bắc ${date}`,
  (date) => `SXTD - XSTD - Xổ số thủ đô Hà Nội ${date}`,
];

function esc(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function weekdayPhrase(dow) {
  return dow === 0 ? "chủ nhật" : `thứ ${dow + 1}`;
}

export function stationFrom(item) {
  const code = item?.province?.code || item?.provinceCode || "";
  if (!code) return null;
  return {
    code,
    name: item?.province?.name || item?.provinceName || "Miền Bắc",
    prizes: item?.prizes || {},
  };
}

function pairOf(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (digits.length < 2) return null;
  return digits.slice(-2);
}

function pairsOf(prizes) {
  const out = [];
  PRIZE_ROWS.forEach((row) => {
    (prizes?.[row.key] || []).forEach((value) => {
      const pair = pairOf(value);
      if (pair) out.push({ pair, special: row.key === "specialPrize" });
    });
  });
  return out;
}

function bucketCells(buckets) {
  return buckets.map((bucket) =>
    [...bucket.entries()]
      .sort((a, b) => a[0].localeCompare(b[0]))
      .map(([digit, entry]) => {
        const sup = entry.count > 1 ? `<sup>${entry.count}</sup>` : "";
        const body = `${digit}${sup}`;
        return entry.special ? `<span class="clnote">${body}</span>` : body;
      })
      .join(", ")
  );
}

function lotoHtml(prizes) {
  const byHead = Array.from({ length: 10 }, () => new Map());
  const byTail = Array.from({ length: 10 }, () => new Map());
  pairsOf(prizes).forEach(({ pair, special }) => {
    const head = pair[0];
    const tail = pair[1];
    const headBucket = byHead[Number(head)];
    const headEntry = headBucket.get(tail) || { count: 0, special: false };
    headEntry.count += 1;
    if (special) headEntry.special = true;
    headBucket.set(tail, headEntry);

    const tailBucket = byTail[Number(tail)];
    const tailEntry = tailBucket.get(head) || { count: 0, special: false };
    tailEntry.count += 1;
    if (special) tailEntry.special = true;
    tailBucket.set(head, tailEntry);
  });

  const heads = bucketCells(byHead);
  const tails = bucketCells(byTail);
  const left = [];
  const right = [];
  for (let digit = 0; digit < 10; digit += 1) {
    left.push(`<tr><td class="clnote">${digit}</td><td class="v-loto-dau-${digit}">${heads[digit]}</td></tr>`);
    right.push(
      `<tr><td class="v-loto-duoi-${digit}">${tails[digit]}</td><td class="clnote">${digit}</td></tr>`
    );
  }
  const head = `<tr class="header"><th>Đầu</th><th>Đuôi</th></tr>`;
  return `<table class="firstlast-mb fl"><tbody>${head}${left.join("")}</tbody></table><table class="firstlast-mb fr"><tbody>${head}${right.join("")}</tbody></table>`;
}

function numberSpans(row, values) {
  const count = Math.max(row.slots, values.length);
  const parts = [];
  for (let index = 0; index < count; index += 1) {
    const cls = row.single ? row.cls : `${row.prefix}-${index}`;
    const text = values[index] != null ? esc(values[index]) : "";
    parts.push(`<span data-nc="${row.nc}" class="${cls}">${text}</span>`);
  }
  return parts.join("");
}

function resultTable(station) {
  const body = PRIZE_ROWS.map((row) => {
    const values = (station.prizes?.[row.key] || []).map((value) => String(value));
    const tr = row.tr ? ` class="${row.tr}"` : "";
    return `<tr${tr}><td class="txt-giai">${row.label}</td><td class="v-giai number">${numberSpans(row, values)}</td></tr>`;
  }).join("");
  return `<div data-id="kq" class="one-city" data-region="1" data-zoom="0" data-hover="1"><table class="kqmb extendable"><tbody>${body}</tbody></table>`;
}

function digitsForm(index) {
  const name = `showed-digits-${index + 1}`;
  return `<div class="control-panel"><form class="digits-form"><label class="radio" data-value="0"><input type="radio" name="${name}" value="0" checked><b></b><span></span></label><label class="radio" data-value="2"><input type="radio" name="${name}" value="2"><b></b><span></span></label><label class="radio" data-value="3"><input type="radio" name="${name}" value="3"><b></b><span></span></label></form></div>`;
}

function dayTitle(index, dash, rel) {
  const format = TITLES[index] || TITLES[TITLES.length - 1];
  return format(dash, rel);
}

function subtitle(index, dow) {
  const phrase = `XSMB ${weekdayPhrase(dow)}`;
  const link = `<span class="sub-title">${esc(phrase)}</span>`;
  if (index !== 0) return link;
  return `<span class="sub-title">XSMB</span> » ${link}`;
}

function statCells(items, unit) {
  const rows = [];
  for (let index = 0; index < items.length; index += 5) {
    const cells = items
      .slice(index, index + 5)
      .map(
        (item) =>
          `<td><b class="clnote">${esc(item.label)}</b> <span class="dsp-mobile-block">${esc(item.count)} ${unit}</span></td>`
      )
      .join("");
    rows.push(`<tr>${cells}</tr>`);
  }
  return rows.join("");
}

function statTable(title, items, unit) {
  return `<div class="statistic-box mag5"><table class="with-border"><tr><th colspan="5"><div class="">${title}</div></th></tr>${statCells(items, unit)}</table></div>`;
}

function quickStats(stats) {
  if (!stats) return "";
  const hot = stats.hot.map((item) => ({ label: item.pair, count: item.count }));
  const gan = stats.gan.map((item) => ({ label: item.pair, count: item.gap }));
  return `<div id="thong-ke-nhanh"><div class="regional-title bold mag5-0 txt-center">Các bộ số về nhiều và ít nhất 30 lần quay</div><div class="tab-thong-ke-inline"><div><span>Lô gan</span></div><div><span>Tần suất</span></div><div><span>Nhanh</span></div><div><span>Đầu đuôi</span></div></div>${statTable("Bộ số lâu chưa về nhất", gan, "ngày")}${statTable('Bộ số về <b class="clnote">nhiều</b> nhất 30 ngày', hot, "lần")}</div>`;
}

function specialCell(value, weekend) {
  const grey = weekend ? " bg-grey" : "";
  if (!value) return `<td class="pad5-0${grey}"></td>`;
  const text = String(value);
  const head = esc(text.slice(0, -2));
  const tail = esc(text.slice(-2));
  return `<td class="pad5-0${grey}"><span>${head}<span class="clred">${tail}</span></span></td>`;
}

function specialBoard(history) {
  const draws = [...(history || [])].reverse().map((day) => ({
    dow: day.dow,
    dash: day.dash,
    value: day.rows?.[0]?.prizes?.specialPrize?.[0] || "",
  }));
  if (!draws.length) return "";
  const rows = [];
  let row = null;
  let prev = -1;
  draws.forEach((draw) => {
    const index = WEEK_COLS.indexOf(draw.dow);
    if (index < 0) return;
    if (!row || index <= prev) {
      row = Array(7).fill("");
      rows.push(row);
    }
    row[index] = draw.value;
    prev = index;
  });
  const from = draws[0].dash;
  const to = draws[draws.length - 1].dash;
  const head = ["Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7", "CN"]
    .map((label) => `<th class="pad5-0">${label}</th>`)
    .join("");
  const body = rows
    .map((cells) => {
      const tds = cells.map((value, index) => specialCell(value, index >= 5)).join("");
      return `<tr class="s15 bold">${tds}</tr>`;
    })
    .join("");
  return `<div class="box mag5-0"><div class="regional-title mag5-0 bold txt-center">Thống kê giải đặc biệt 30 ngày từ ${esc(from)} tới ${esc(to)}</div><div class="tab-thong-ke-inline"><div><span>Giải đặc biệt</span></div><div><span>Theo năm</span></div><div><span>Theo tháng</span></div><div><span>Theo tuần</span></div></div><div class="statistic-box"><table class="with-border"><tbody><tr>${head}</tr>${body}</tbody></table></div></div>`;
}

export function buildStats(days) {
  const freq = new Map();
  const lastIndex = new Map();
  days.forEach((day, index) => {
    const seen = new Set();
    (day.rows || []).forEach((row) => {
      pairsOf(row?.prizes).forEach(({ pair }) => {
        freq.set(pair, (freq.get(pair) || 0) + 1);
        seen.add(pair);
      });
    });
    seen.forEach((pair) => {
      if (!lastIndex.has(pair)) lastIndex.set(pair, index);
    });
  });
  const ranked = [];
  for (let index = 0; index < 100; index += 1) {
    const pair = String(index).padStart(2, "0");
    ranked.push({ pair, count: freq.get(pair) || 0 });
  }
  const hot = [...ranked].sort((a, b) => b.count - a.count || a.pair.localeCompare(b.pair)).slice(0, 10);
  const gan = [];
  for (let index = 0; index < 100; index += 1) {
    const pair = String(index).padStart(2, "0");
    const gap = lastIndex.has(pair) ? lastIndex.get(pair) : days.length;
    if (gap > 0) gan.push({ pair, gap });
  }
  gan.sort((a, b) => b.gap - a.gap || a.pair.localeCompare(b.pair));
  return { hot, gan: gan.slice(0, 10) };
}

function relative(date, today, yesterday, ereyesterday) {
  if (date === today) return "today";
  if (date === yesterday) return "yesterday";
  if (date === ereyesterday) return "ereyesterday";
  return "";
}

export function renderPage({ dow, days, stats, history, today, yesterday, ereyesterday }) {
  const tabs = `<ul class="tab-panel">${TABS.map((tab) => {
    const active = tab.dow === dow ? " class='active'" : "";
    const title = tab.dow === "all" ? "" : ` title="${esc(tab.title)}"`;
    return `<li${active} data-dow="${tab.dow}"><a${title}>${tab.label}</a></li>`;
  }).join("")}</ul>`;

  const boxes = days
    .map((day, index) => {
      const rel = relative(day.date, today, yesterday, ereyesterday);
      const statsHtml = index === 0 ? quickStats(stats) : "";
      return `<div class="box"><div class="regional-title clearfix"><h2>${esc(dayTitle(index, day.dash, rel))}</h2><div>${subtitle(index, day.dow)}</div></div><div id="load_kq_mb_${index}">${resultTable(day.station)}${digitsForm(index)}</div><div data-id="dd" class="col-firstlast clearfix">${lotoHtml(day.station.prizes)}</div></div>${statsHtml}</div>`;
    })
    .join("");

  const extra = days.length ? specialBoard(history) : "";
  return `${tabs}${boxes}${extra}`;
}
